<template>
  <article class="cta-cards">
    <a
      v-for="(card, index) in requestCards"
      :key="index"
      :href="card.card.link.url"
      class="card"
      :target="card.card.target"
    >
      <div class="title">
        <img :src="card.card.svg_icon" alt="" />
        <h4 v-html="card.card.title" />
      </div>
      <div v-html="card.card.text" />
      <button class="btn n-btn inline icon-right">
        {{ card.card.link.title }}
        <svg class="icon"><use href="#arrow-right-long" /></svg>
      </button>
    </a>
  </article>
</template>

<script>
export default {
  props: {
    cards: {
      required: true,
      type: Object,
    },
    requestType: {
      default: '',
      type: String,
    },
  },

  computed: {
    requestCards() {
      if (this.requestType) {
        return this.cards[this.requestType]
          ? this.cards[this.requestType]
          : this.cards.default;
      }
      return this.cards.default;
    },
  },
};
</script>
